import Const from 'constants';

let Team = {
    setExposureMaxOfUsedTeam(exposureMaxPercent, teamName) {
        return {
            type: Const.SET_EXPOSURE_MAX_OF_USED_TEAM,
            exposureMaxPercent,
            teamName,
        };
    },
};

export default Team;
